"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const api_1 = require("../../services/api");
let TaskModel = class TaskModel {
    constructor(apiService) {
        this.apiService = apiService;
        this.get = (taskId) => this.apiService
            .get(`/api/monitoring/tasks/${taskId}`);
        /** Fetches the latest 100 `EnrichedTask`s from the server.
         * This is meant for admins. */
        this.getAll = () => this.apiService
            .get('/api/monitoring/tasks');
        /** Fetches the latest 100 `EnrichedTask`s from the server.
         * Returns the tasks that are assigned to the current user and are still open. */
        this.getAllOpen = () => this.apiService
            .get('/api/monitoring/open-tasks');
        /** Fetches the latest 100 `EnrichedTask`s from the server.
         * Returns the tasks that are created by the current user */
        this.getAllCreated = () => this.apiService
            .get('/api/monitoring/created-tasks');
        this.deleteTask = (taskId) => this.apiService
            .delete(`/api/monitoring/tasks/${taskId}`);
        this.updateTaskState = (taskId, state) => this.apiService
            .put('/api/monitoring/task-state', { taskId, state });
    }
};
TaskModel = __decorate([
    (0, core_1.Injectable)(),
    __metadata("design:paramtypes", [typeof (_a = typeof api_1.ApiService !== "undefined" && api_1.ApiService) === "function" ? _a : Object])
], TaskModel);
exports.default = TaskModel;
